import { useEffect, useRef } from "react";
import { Backdrop } from "../components/Backdrop";
import { useT } from "../i18n/context";

/**
 * The server moved on to a protocol this build cannot read (a release while the Activity stayed
 * open): nothing on screen would ever change again, so say so and offer the one thing that helps.
 * A button, not an automatic reload: a reload that does not help must not loop. See docs/ekranlar/masa.md.
 */
export function Update() {
  const { t } = useT();
  const reload = useRef<HTMLButtonElement>(null);
  useEffect(() => reload.current?.focus(), []);
  return (
    <div className="relative isolate flex h-full flex-col items-center justify-center gap-6 overflow-hidden p-4 pb-20 font-ui text-ink">
      <Backdrop />
      <img
        src="/logo.svg"
        alt={t("app.name")}
        className="relative w-[min(80vw,460px)] drop-shadow-[0_16px_30px_rgb(0_0_0/0.7)]"
      />
      <div role="alert" className="relative flex flex-col items-center gap-3.5">
        <p className="max-w-[min(92vw,560px)] rounded-[28px] border-[1.5px] border-edge bg-panel px-[26px] py-3.5 text-center shadow-panel">
          <span className="block text-[18px] font-bold">{t("update.title")}</span>
          <span className="mt-1 block text-[14px] text-ink/75">{t("update.body")}</span>
        </p>
        <button
          ref={reload}
          type="button"
          className="btn-gold h-14 rounded-pill px-[34px] text-[17px] font-extrabold"
          onClick={() => window.location.reload()}
        >
          {t("update.reload")}
        </button>
      </div>
    </div>
  );
}
